const defaultTimeZone = "America/New_York";

const STATIC_URL = process.env.WEBPACK_IMG_URL ? process.env.WEBPACK_IMG_URL : "https://static.gpshopper.com/img/md5/";

const supplementalDataFieldOptions = {
  banners: [
    {
      label: "ADA Compliance - accessibility_label",
      value: "accessibility_label",
    },
    { label: "Program Name - program_name", value: "program_name" },
  ],
  promotions: [
    {
      label: "ADA Compliance - accessibility_label",
      value: "accessibility_label",
    },
    { label: "Program Name - program_name", value: "program_name" },
    { label: "Product Type", value: "product_type" },
    { label: "Card Art URL", value: "card_art_url" },
  ],
};

export { defaultTimeZone, supplementalDataFieldOptions, STATIC_URL };